module.exports = __webpack_public_path__ + "static/media/img-newtaipeicity-zh-mobile.7e87423d.svg";